// /frontend/src/config/navigation.ts

/**
 * Configuration for the application's navigation structure.
 * This file defines the items that appear in the main navigation drawer.
 *
 * @author Alexander Funke
 * @lastChange 2026-04-14
 */

/** @interface INavItem Defines a single navigation link. */
export interface INavItem {
  title: string;
  icon: string;
  to: string;
}

/** @interface INavGroup Defines a group of navigation links. */
export interface INavGroup {
  title: string;
  icon: string;
  items: INavItem[];
}

/** @interface TNavItem A union type for any item in the navigation array. */
export type TNavItem = INavItem | INavGroup | { divider: boolean };

/**
 * @const mainNavigation
 * @description Defines the primary navigation items.
 */
export const mainNavigation: TNavItem[] = [
  { title: 'views.dashboard.title', icon: 'mdi-view-dashboard', to: '/dashboard' },
  { divider: true },
  {
    title: 'views.devices.title',
    icon: 'mdi-check-network-outline',
    to: '/devices',
  },
  { title: 'views.servers.title', icon: 'mdi-server-network-outline', to: '/servers' },
  { title: 'views.companies.title', icon: 'mdi-domain', to: '/companies' },
];

/**
 * @const secondaryNavigation
 * @description Defines items that appear at the bottom of the navigation.
 */
export const secondaryNavigation: TNavItem[] = [
  { divider: true },
  { title: 'views.control-panel.title', icon: 'mdi-key-chain', to: '/control-panel' },
  { title: 'views.settings.title', icon: 'mdi-cog-outline', to: '/settings' },
];
